<template>
  <b-card style="margin-top: 70px">
    <h1 class="text-center">
      Tienes {{ syncAsistencias.length }}
      {{ syncAsistencias.length === 1 ? "asistencia" : "asistencias" }} por
      sincronizar
    </h1>

    <b-row class="mt-5">
      <b-col class="text-center">
        <b-button
          :disabled="disableBtn || syncAsistencias.length <= 0"
          @click="store()"
          variant="success mt-5 h2"
        >
          Sincronizar
        </b-button>
        <b-spinner
          v-if="disableBtn"
          variant="success"
          class="h2 ml-3"
          style="vertical-align: text-top"
          label="Spinning"
        ></b-spinner>
      </b-col>
    </b-row>

    <b-modal id="modal-progress" title="Progreso" hide-footer>
      <b-progress
        :value="progressValue"
        max="100"
        show-progress
        animated
      ></b-progress>
    </b-modal>

    <!-- <b-row class="mt-5">
      <b-col class="text-center">
         <b-button @click="createAsistencias()" :disabled='disableBtn2' variant="success mt-5 h2">
            Crear asistencias
         </b-button>
      </b-col>
    </b-row> -->
  </b-card>
</template>
<script>
//import BusEvent from "../../../busEvent";

import ApiService from "../../core/services/api.service";
//import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from "vuex";
///const axios = require("axios");

export default {
  name: "UsersP",

  components: {
    //InfiniteLoading
  },

  data() {
    return {
      disableBtn: false,
      disableBtn2: false,
      totalStart: 0,
      process: 0,
      errors: 0,
      //localAddress: "//appagricactus.xyz",
      // localAddress : '//localhost:3000/api/v1'
    };
  },

  methods: {
    randomString(length) {
      const chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    createAsistencias() {
      let usuarios = this.users;
      const self = this;

      usuarios.map((u) => {
        self.$store.dispatch("storeAsistencia2", {
          user_id: u.id,
          jornadaId: 9,
          date: self.getDateTime(),
          actividadId: 7,
          cuadroId: 7,
        });
      });

      setTimeout(() => {
        self.$store.dispatch("getSyncAsis");
      }, 10000);

      this.disableBtn2 = true;
    },
    getDateTime() {
      const d = new Date();
      return (
        d.toJSON().slice(0, 10).replace(/-/g, "-") +
        " " +
        d.toLocaleTimeString()
      );
    },
    async store() {
      let totalErrors = 0;

      try {
        this.disableBtn = true;
        const assistancesPromise = this.syncAsistencias.map(
          async (assistance) => {
            try {
              await ApiService.post("asistencia/nw", assistance);

              this.$store.dispatch("remove", {
                _id: assistance._id,
                _rev: assistance._rev,
              });
            } catch (err) {
              totalErrors++;
            }
          }
        );
        await Promise.all(assistancesPromise);
        this.$toasted.show(
          `Se sincronizaron las asistencias exitosamente con ${totalErrors} errores.`,
          {
            duration: 1500,
            type: "success",
          }
        );
        this.$store.dispatch("getSyncAsis");
      } catch (err) {
        let message = `Hubo un error al sincronizar: ${err.message}`;
        const isNetworkError = err.message.includes("Network");
        if (isNetworkError) {
          message = "No tienes conexión a la red.";
        }
        this.$toasted.show(message, {
          duration: 1500,
          type: "error",
        });
      } finally {
        this.disableBtn = false;
        this.$bvModal.hide("modal-progress");
      }

    
    },
  },
  mounted() {
    this.$store.dispatch("getSyncAsis");
  },
  computed: {
    ...mapState({
      syncAsistencias: (state) => state.asistencias.syncAsistencias,
      users: (state) => state.users.users,
    }),
    progressValue() {
      return (100 / this.totalStart) * this.process;
    },
  },
  destroyed() {},
};
</script>

<style>
.custom-card {
  background-color: #ffffff;
  margin: 5px 5px 8px 5px;
  padding: 5px;
  border-radius: 4px;
  border-color: #444444;
  font-size: 14px;
}

.option-container {
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 10px 5px;
}
.input-radio-l {
  margin: 5px;
  align-self: center;
}

.input-radio {
  margin: 5px;
  padding-top: 8px;
  align-self: center;
  height: 20px;
  width: 20px;
  vertical-align: middle;
}
</style>
